<template>
<div class="chapter">
<div class="inner_page">
<p class="statement"><i>“Mathematics, rightly viewed, possesses not only truth, but supreme beauty—a beauty cold and austere, like that of sculpture.”</i></p>
<p class="statement_right"> —Bertrand Russell, <i>Mysticism and Logic</i>, 1918</p>
<p class="statement"><i>“Mathematics is a wonderful, mad subject, full of imagination, fantasy, and creativity that is not limited by the petty details of the physical world, but only by the strength of our inner light.”</i></p>
<p class="statement_right">—Gregory Chaitin, “Less Proof, More Truth,”<br/><i>New Scientist</i>, July 28, 2007</p>
<p class="statement"><i>“Perhaps an angel of the Lord surveyed an endless sea of chaos, then troubled it gently with his finger. In this tiny and temporary swirl of equations, our cosmos took shape.”</i></p>
<p class="statement_right">—Martin Gardner, <i>Order and Surprise</i>, 1950</p>
<p class="statement"><i>“The great equations of modern physics are a permanent part of scientific knowledge, which may outlast even the beautiful cathedrals of earlier ages.”</i></p>
<p class="statement_right">—Steven Weinberg, in Graham Farmelo’s<br/><i>It Must Be Beautiful</i>, 2002</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?4f9c3e79